import { useRef } from 'react';
import { IModalRefProps } from 'ui/components/Modals/Modal/types';

import { PAGES } from '~/constants/pages.constants';
import { useAppSelector } from '~/hooks/useAppSelector';

export const useActivityMetricsController = () => {
  const modalRef = useRef<IModalRefProps>(null);

  const modalInfoRef = useRef<IModalRefProps>(null);

  const { selectedEcosystem } = useAppSelector(({ ecosystem }) => ecosystem);

  const handleOpenModal = () => {
    modalRef.current?.open();
  };

  const handleCloseModal = () => {
    modalRef.current?.close();
  };

  const handleOpenModalInformation = () => {
    modalInfoRef.current?.open();
  };

  const unitsHelpLink = `${PAGES.EDIT_ECOSYSTEM}/${
    selectedEcosystem?._id || ''
  }`;

  return {
    handleOpenModal,
    handleCloseModal,
    handleOpenModalInformation,
    modalRef,
    modalInfoRef,
    unitsHelpLink,
  };
};
